<template>
  <div id="app">
    <router-view/>
    <!-- 页脚 -->
    <footer v-if="showFooter" class="footer">
      <div class="footer-content">
        <p class="footer-text">{{ footerText }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import siteConfigService from './services/siteConfig'

export default {
  name: 'App',
  data() {
    return {
      footerText: ''
    }
  },
  computed: {
    showFooter() {
      return this.footerText && this.$route.name !== 'Agent'
    }
  },
  async mounted() {
    // 加载网站配置
    await this.loadSiteConfig()
  },
  methods: {
    async loadSiteConfig() {
      try {
        const config = await siteConfigService.getFrontendConfigs()
        if (config) {
          this.footerText = config.footer_text || ''
        }
      } catch (error) {
        console.error('加载网站配置失败:', error)
      }
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  background-color: #141414;
  display: flex;
  flex-direction: column;
}

.footer {
  background-color: #1a1a1a;
  border-top: 1px solid #2d2d2d;
  padding: 20px 0;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
}

.footer-text {
  color: #888;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

@media (max-width: 768px) {
  .footer {
    padding: 15px 0;
  }
  
  .footer-text {
    font-size: 12px;
    padding: 0 10px;
  }
}
</style>
